const isProd = import.meta.env.MODE === "production";

export const AUTH_API_URL = `https://api.izilifepay.com/api`;

const PROD_MAIN_URL = 'https://cms-api.kafintechgroup.com';

export const MAIN_API_URL = `${PROD_MAIN_URL}/api`;

export const MAIN_URL = PROD_MAIN_URL;


